import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isMostRequested", "isActive", "slotNumber", "headerTitle", "type", "onClick", "description", "ctaLabel", "onCtaClick", "ctaStartIcon", "isCtaDisabled", "isCtaLoading"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { Badge } from '@restworld/ui-ds-base';
import IconButton from '../icon-button';
import { SkeletonTextLoading } from '../skeleton-loading';
import { ButtonV2 } from '../button-v2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var CardContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__CardContainer",
  componentId: "sc-fs5hun-0"
})(["", " ", " ", " ", " ", ";", ""], {
  "position": "relative",
  "minHeight": "320px",
  "width": "100%",
  "maxWidth": "720px",
  "cursor": "pointer",
  "overflow": "hidden",
  "padding": "1.25rem"
}, {
  "borderRadius": "16px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))"
}, {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "space-between",
  "gap": "1rem"
}, {
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "200ms"
}, function (_ref) {
  var isActive = _ref.isActive,
      type = _ref.type;

  if (type === 'trial') {
    return [{
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))"
    }, isActive ? {
      "borderWidth": "2px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(102 51 187 / var(--tw-border-opacity))"
    } : {
      "borderWidth": "2px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))"
    }, isActive ? "box-shadow: 0 10px 28px 0 rgba(72, 36, 133, 0.55), 0 0 0 3px rgba(102, 51, 187, 0.10);" : "box-shadow: 0 4px 16px 0 rgba(72, 36, 133, 0.35);"];
  }

  return [isActive ? {
    "borderWidth": "2px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(102 51 187 / var(--tw-border-opacity))"
  } : {
    "borderWidth": "2px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))"
  }, isActive ? "box-shadow: 0 10px 28px 0 rgba(0, 0, 26, 0.20), 0 0 0 3px rgba(102, 51, 187, 0.10);" : "box-shadow: 0 4px 16px 0 rgba(0, 0, 26, 0.12);"];
}, function (_ref2) {
  var isActive = _ref2.isActive;
  return !isActive && "\n    &:hover {\n      border: 2px solid ".concat("#693eb5", ";\n      box-shadow: 0 4px 16px 0 rgba(0, 0, 26, 0.15);\n    }\n  ");
});

var ContentContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__ContentContainer",
  componentId: "sc-fs5hun-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "2rem",
  "alignSelf": "stretch"
});

var HeaderTop = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__HeaderTop",
  componentId: "sc-fs5hun-2"
})({
  "display": "inline-flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "alignSelf": "stretch"
});

var HeaderLeft = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__HeaderLeft",
  componentId: "sc-fs5hun-3"
})({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.75rem",
  "borderRadius": "0.5rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem"
});

var IconContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__IconContainer",
  componentId: "sc-fs5hun-4"
})(["", " ", ";", ""], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center"
}, {
  "height": "1rem",
  "width": "1rem",
  "borderRadius": "384px"
}, function (_ref3) {
  var isActive = _ref3.isActive,
      type = _ref3.type;
  if (isActive) return {
    "borderWidth": "2px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(102 51 187 / var(--tw-border-opacity))"
  };
  return {
    "borderWidth": "2px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))"
  };
});

var InnerIcon = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__InnerIcon",
  componentId: "sc-fs5hun-5"
})(["", " ", ""], {
  "height": "0.5rem",
  "width": "0.5rem",
  "borderRadius": "9999px"
}, function (_ref4) {
  var isActive = _ref4.isActive;
  return isActive ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(102 51 187 / var(--tw-bg-opacity))"
  } : {
    "backgroundColor": "transparent"
  };
});

var HeaderText = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__HeaderText",
  componentId: "sc-fs5hun-6"
})(["", " ", ""], {
  "fontSize": "1rem",
  "lineHeight": "1",
  "fontWeight": "600"
}, function (_ref5) {
  var type = _ref5.type;
  return type === 'trial' ? {
    "fontWeight": "700",
    "--tw-text-opacity": "1",
    "color": "rgb(72 36 133 / var(--tw-text-opacity))"
  } : {
    "fontWeight": "500",
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))"
  };
});

var HeaderRight = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__HeaderRight",
  componentId: "sc-fs5hun-7"
})({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "flex-end",
  "gap": "0.125rem"
});

var Price = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__Price",
  componentId: "sc-fs5hun-8"
})(["", " ", ""], {
  "fontWeight": "600"
}, function (_ref6) {
  var type = _ref6.type;
  return type === 'trial' ? {
    "fontSize": "1.5rem",
    "lineHeight": "2rem",
    "fontWeight": "800",
    "--tw-text-opacity": "1",
    "color": "rgb(72 36 133 / var(--tw-text-opacity))"
  } : {
    "fontSize": "0.875rem",
    "lineHeight": "1.25rem",
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))"
  };
});

var Tax = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__Tax",
  componentId: "sc-fs5hun-9"
})(["", " ", ""], {
  "fontSize": "0.875rem",
  "lineHeight": "21px",
  "fontWeight": "300"
}, function (_ref7) {
  var type = _ref7.type;
  return type === 'trial' ? {
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))"
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))"
  };
});

var Description = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__Description",
  componentId: "sc-fs5hun-10"
})({
  "alignSelf": "stretch",
  "fontSize": "0.875rem",
  "lineHeight": "16px",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});

var CardBody = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__CardBody",
  componentId: "sc-fs5hun-11"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.25rem",
  "alignSelf": "stretch"
});

var BodyText = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__BodyText",
  componentId: "sc-fs5hun-12"
})(["", " ", ""], {
  "alignSelf": "stretch",
  "fontSize": "0.875rem",
  "lineHeight": "21px",
  "fontWeight": "400"
}, function (_ref8) {
  var type = _ref8.type;
  return type === 'trial' ? {
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))"
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(102 102 118 / var(--tw-text-opacity))"
  };
});

var Footer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__Footer",
  componentId: "sc-fs5hun-13"
})(["", " ", ""], {
  "display": "inline-flex",
  "height": "3rem",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "1.25rem",
  "alignSelf": "stretch",
  "borderRadius": "0.5rem",
  "paddingLeft": "5rem",
  "paddingRight": "5rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem"
}, function (_ref9) {
  var isActive = _ref9.isActive;
  return isActive ? {
    "backgroundColor": "transparent"
  } : {
    "backgroundColor": "transparent"
  };
});

var FooterButton = /*#__PURE__*/_styled(IconButton).withConfig({
  displayName: "slot-purchase-card__FooterButton",
  componentId: "sc-fs5hun-14"
})({
  "display": "flex",
  "width": "2.5rem",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.5rem",
  "padding": "0.5rem"
});

var FooterText = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__FooterText",
  componentId: "sc-fs5hun-15"
})(["", " ", " ", " ", ""], {
  "width": "auto",
  "whiteSpace": "nowrap"
}, {
  "textAlign": "center"
}, {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500"
}, function (_ref10) {
  var isActive = _ref10.isActive;
  return isActive ? {
    "--tw-text-opacity": "1",
    "color": "rgb(72 36 133 / var(--tw-text-opacity))"
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(117 117 131 / var(--tw-text-opacity))"
  };
});

var HeaderLeftComponent = function HeaderLeftComponent(_ref11) {
  var isActive = _ref11.isActive,
      headerTitle = _ref11.headerTitle,
      type = _ref11.type;
  return /*#__PURE__*/_jsxs(HeaderLeft, {
    children: [type !== 'subscription' && /*#__PURE__*/_jsx(IconContainer, {
      isActive: isActive,
      type: type,
      children: /*#__PURE__*/_jsx(InnerIcon, {
        isActive: isActive
      })
    }), /*#__PURE__*/_jsx(HeaderText, {
      type: type,
      children: headerTitle
    })]
  });
};

var HeaderRightComponent = function HeaderRightComponent(_ref12) {
  var _discount$discount, _discount$discount2, _discount$discount3;

  var bundlePrice = _ref12.bundlePrice,
      slotPrice = _ref12.slotPrice,
      type = _ref12.type,
      discountPrice = _ref12.discountPrice,
      loading = _ref12.loading,
      discount = _ref12.discount;
  return /*#__PURE__*/_jsx(HeaderRight, {
    children: loading ? /*#__PURE__*/_jsx(SkeletonTextLoading, {
      width: "xSmall"
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [discountPrice !== (slotPrice !== null && slotPrice !== void 0 ? slotPrice : 0) - ((_discount$discount = discount === null || discount === void 0 ? void 0 : discount.discount) !== null && _discount$discount !== void 0 ? _discount$discount : 0) && /*#__PURE__*/_jsxs(_StyledH, {
        children: [discountPrice, "\u20AC"]
      }), /*#__PURE__*/_jsx(Price, {
        type: type,
        children: type !== 'custom' ? "".concat((bundlePrice || 0) - ((_discount$discount2 = discount === null || discount === void 0 ? void 0 : discount.discount) !== null && _discount$discount2 !== void 0 ? _discount$discount2 : 0), "\u20AC").concat(type === 'subscription' ? "/mese" : '') : "".concat((slotPrice || 0) - ((_discount$discount3 = discount === null || discount === void 0 ? void 0 : discount.discount) !== null && _discount$discount3 !== void 0 ? _discount$discount3 : 0), "\u20AC")
      }), /*#__PURE__*/_jsx(Tax, {
        type: type,
        children: "+ iva"
      })]
    })
  });
};

var CardBodyComponent = function CardBodyComponent(_ref13) {
  var slotPurchaseDescriptions = _ref13.slotPurchaseDescriptions,
      type = _ref13.type;
  return /*#__PURE__*/_jsx(CardBody, {
    children: slotPurchaseDescriptions === null || slotPurchaseDescriptions === void 0 ? void 0 : slotPurchaseDescriptions.map(function (text, index) {
      return /*#__PURE__*/_jsx(BodyText, {
        type: type,
        children: text
      }, index);
    })
  });
};

var FooterComponent = function FooterComponent(_ref14) {
  var isActive = _ref14.isActive,
      onSlotAdd = _ref14.onSlotAdd,
      onSlotMinus = _ref14.onSlotMinus,
      slotNumber = _ref14.slotNumber;
  return /*#__PURE__*/_jsxs(Footer, {
    isActive: isActive,
    children: [/*#__PURE__*/_jsx(FooterButton, {
      size: "md",
      ariaLabel: "minus",
      Icon: MinusIcon,
      variant: isActive ? 'restworld' : 'neutral',
      disabled: !isActive || slotNumber === 1,
      onClick: onSlotMinus
    }), /*#__PURE__*/_jsxs(FooterText, {
      isActive: isActive,
      children: [slotNumber, "\xA0", "slot"]
    }), /*#__PURE__*/_jsx(FooterButton, {
      size: "md",
      ariaLabel: "plus",
      Icon: PlusIcon,
      variant: isActive ? 'restworld' : 'neutral',
      disabled: !isActive || slotNumber === 10,
      onClick: onSlotAdd
    })]
  });
};

var LogoWatermark = function LogoWatermark() {
  return /*#__PURE__*/_jsx(_StyledSvg, {
    style: {
      width: '550.063px',
      height: '467.895px',
      transform: 'rotate(-15deg)',
      left: '-183.699px',
      top: '-200.586px'
    },
    width: "320",
    height: "200",
    viewBox: "0 0 320 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M375.329 -67.3658C361.708 -76.0023 343.602 -71.9593 334.943 -58.3331C333.519 -56.0917 299.838 -2.50417 279.279 71.5403C268.479 110.478 262.014 147.654 258.176 176.611C244.025 166.168 228.871 155.466 212.892 144.609C198.699 134.986 183.52 124.986 167.514 115.895C190.887 72.3523 200.222 17.2607 191.333 -28.0868C183.053 -70.3601 165.943 -99.0332 139.054 -115.682C110.229 -133.528 74.8636 -133.831 48.9635 -116.417C8.15039 -89.0064 -11.7445 -18.7827 0.563755 54.3376C2.07319 63.3373 4.15644 73.0631 6.75614 83.388C-55.1053 93.1077 -108.471 134.355 -115.162 177.806C-119.33 204.802 -105.64 228.795 -78.568 241.966C-46.0751 257.778 0.0162276 251.286 51.1786 223.675C52.8604 222.75 54.5596 221.818 56.2591 220.864C73.1221 259.364 87.2842 287.254 88.9905 290.604C96.3094 304.951 113.96 310.672 128.358 303.363C135.328 299.801 140.493 293.753 142.91 286.321C145.327 278.89 144.673 270.949 141.115 263.995C140.395 262.548 123.815 229.8 105.578 187.242C115.194 179.425 124.089 171.381 132.127 163.178C148.489 172.007 164.727 182.674 180.031 193.052C233.684 229.454 262.753 254.424 263.058 254.674L308.834 294.208L311.423 233.76C311.45 233.064 314.756 162.591 335.692 87.2041C353.649 22.4717 383.172 -25.0537 384.37 -26.9906C393.018 -40.613 388.948 -58.729 375.329 -67.3658ZM-51.773 192.172C-56.5826 189.32 -58.5625 183.35 -57.9719 179.17C-56.8331 171.249 -39.8335 155.358 2.43748 144.031C7.19352 142.757 12.0653 141.761 16.9422 141.025C19.3462 140.665 21.7353 140.358 24.1197 140.099C27.1529 148.667 30.3757 157.661 33.8907 166.765C-8.4497 191.78 -40.831 198.621 -51.773 192.172ZM114.033 91.5894C98.3399 86.4135 82.758 83.0919 66.8088 81.4839C62.9776 67.8953 60.1135 55.5213 58.2818 44.6047C49.027 -10.2873 61.6241 -53.5385 78.1936 -66.3314C78.3475 -66.4672 96.5616 -79.0835 113.318 -68.6968C130.953 -57.7792 134.798 -36.6019 136.197 -19.3864C138.641 11.0666 133.91 43.5834 123.756 70.5193C120.927 78.0333 117.673 85.1073 114.033 91.5894Z",
      fill: "currentColor"
    })
  });
};

export function SlotPurchaseCard(_ref15) {
  var _discount$discount4, _discount$discount5;

  var isMostRequested = _ref15.isMostRequested,
      isActive = _ref15.isActive,
      slotNumber = _ref15.slotNumber,
      headerTitle = _ref15.headerTitle,
      type = _ref15.type,
      onClick = _ref15.onClick,
      description = _ref15.description,
      ctaLabel = _ref15.ctaLabel,
      onCtaClick = _ref15.onCtaClick,
      ctaStartIcon = _ref15.ctaStartIcon,
      isCtaDisabled = _ref15.isCtaDisabled,
      isCtaLoading = _ref15.isCtaLoading,
      rest = _objectWithoutProperties(_ref15, _excluded);

  var _useTranslation = useTranslation('product-description-page'),
      t = _useTranslation.t;

  var discount = rest.discount;
  return /*#__PURE__*/_jsxs(CardContainer, {
    onClick: onClick,
    isActive: isActive,
    type: type,
    children: [type === 'trial' && /*#__PURE__*/_jsx(LogoWatermark, {}), ((_discount$discount4 = discount === null || discount === void 0 ? void 0 : discount.discount) !== null && _discount$discount4 !== void 0 ? _discount$discount4 : 0) > 0 && /*#__PURE__*/_jsx(_StyledDiv, {
      children: /*#__PURE__*/_jsx(Badge, {
        variant: "tertiary",
        children: "Sconto di benvenuto: -".concat((_discount$discount5 = discount === null || discount === void 0 ? void 0 : discount.discount) !== null && _discount$discount5 !== void 0 ? _discount$discount5 : 0, "\u20AC")
      })
    }), /*#__PURE__*/_jsxs(ContentContainer, {
      children: [/*#__PURE__*/_jsxs(_StyledDiv2, {
        children: [/*#__PURE__*/_jsxs(HeaderTop, {
          children: [/*#__PURE__*/_jsx(HeaderLeftComponent, {
            type: type,
            isActive: isActive,
            headerTitle: headerTitle
          }), /*#__PURE__*/_jsx(HeaderRightComponent, _objectSpread({
            type: type
          }, rest))]
        }), description && /*#__PURE__*/_jsx(Description, {
          children: description
        })]
      }), /*#__PURE__*/_jsx(CardBodyComponent, _objectSpread(_objectSpread({}, rest), {}, {
        type: type
      })), type === 'trial' && /*#__PURE__*/_jsx(Badge, {
        variant: "fresh",
        children: "offerta speciale"
      }), isMostRequested && /*#__PURE__*/_jsx(Badge, {
        variant: "success",
        children: /*#__PURE__*/_jsx("h5", {
          className: "text-green-700 text-sm font-medium",
          children: t('most_requested')
        })
      })]
    }), (type === 'custom' || type === 'subscription') && /*#__PURE__*/_jsx(FooterComponent, _objectSpread({
      slotNumber: slotNumber,
      isActive: isActive
    }, rest)), ctaLabel && /*#__PURE__*/_jsx(ButtonV2, {
      onClick: function onClick(e) {
        e.stopPropagation();
        onCtaClick === null || onCtaClick === void 0 ? void 0 : onCtaClick();
      },
      fullwidth: true,
      StartIcon: ctaStartIcon,
      variant: isActive && type === 'trial' ? 'primary' : isActive ? 'secondary-restworld' : 'secondary-neutral',
      disabled: isCtaDisabled || !isActive,
      loading: isCtaLoading,
      children: ctaLabel
    })]
  });
}
export default SlotPurchaseCard;

var _StyledH = /*#__PURE__*/_styled("h5").withConfig({
  displayName: "slot-purchase-card___StyledH",
  componentId: "sc-fs5hun-16"
})({
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))",
  "textDecorationLine": "line-through"
});

var _StyledSvg = /*#__PURE__*/_styled("svg").withConfig({
  displayName: "slot-purchase-card___StyledSvg",
  componentId: "sc-fs5hun-17"
})({
  "pointerEvents": "none",
  "position": "absolute",
  "--tw-text-opacity": "1",
  "color": "rgb(102 51 187 / var(--tw-text-opacity))",
  "opacity": "0.03"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "slot-purchase-card___StyledDiv",
  componentId: "sc-fs5hun-18"
})({
  "display": "inline-flex",
  "flexDirection": "row",
  "justifyContent": "flex-end",
  "alignSelf": "stretch"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "slot-purchase-card___StyledDiv2",
  componentId: "sc-fs5hun-19"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.25rem",
  "alignSelf": "stretch"
});